<template>
  <div class="trial-apply-page">
    <main class="trial-apply">
      <header class="trial-apply-header">
        <router-link class="trial-back" to="/home">返回官网首页</router-link>
        <p class="trial-eyebrow">DCMP 企业试用</p>
        <h1>开启您的电池数字护照之旅</h1>
        <p class="trial-description">填写企业信息与试用需求，审核通过后，我们将通过企业邮箱发送激活指引。</p>
        <ol class="trial-process" aria-label="试用申请流程">
          <li><span aria-hidden="true">1</span>填写申请</li>
          <li><span aria-hidden="true">2</span>运营审核</li>
          <li><span aria-hidden="true">3</span>邮件激活</li>
        </ol>
      </header>
      <form-nav />
    </main>
    <footer-nav />
  </div>
</template>

<script>
export default {
  name: 'TrialApply',
  metaInfo: {
    title: '申请 DCMP 企业试用 | 电池数字护照',
    meta: [{ name: 'description', content: '申请 DCMP 企业试用，填写企业信息和试用需求，审核通过后通过企业邮箱激活，开启电池数字护照体验。' }],
    link: [{ rel: 'canonical', href: 'https://www.chdpp.com/trial/' }],
  },
};
</script>

<style scoped>
.trial-apply { background: #f2f7fc; color: #24394b; }
.trial-apply-header { max-width: 1200px; margin: 0 auto; padding: 32px 24px 0; font-size: 18px; line-height: 1.7; }
.trial-apply-header * { box-sizing: border-box; font-size: inherit; }
.trial-back { display: inline-block; color: #456b89; text-decoration: underline; text-underline-offset: 4px; }
.trial-eyebrow { margin: 20px 0 8px; color: #176aab; font-size: 17px; font-weight: 600; }
.trial-apply-header h1 { margin: 0 0 12px; font-size: 36px; line-height: 1.35; font-weight: 600; }
.trial-description { max-width: 840px; margin: 0; color: #526b80; }
.trial-process { display: flex; flex-wrap: wrap; gap: 16px 32px; margin: 24px 0 0; padding: 0; list-style: none; }
.trial-process li { display: flex; align-items: center; gap: 10px; }
.trial-process span { display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 50%; background: #e2effb; color: #176aab; font-size: 16px; font-weight: 600; }
.trial-apply ::v-deep .trial-section { padding-top: 32px; }
@media (max-width: 800px) {
  .trial-apply-header { padding: 24px 20px 0; font-size: 17px; }
  .trial-apply-header h1 { font-size: 28px; }
  .trial-process { gap: 12px 16px; font-size: 16px; }
  .trial-process li { gap: 6px; }
  .trial-process span { width: 24px; height: 24px; font-size: 14px; }
  .trial-apply ::v-deep .trial-section { padding-top: 24px; }
}
</style>
